<mpsm-supplier-icon class="supplier-icon" [type]="supplier().type" [category]="supplier().category" />

<div class="supplier-info truncate">
  <span class="supplier-info__name truncate" [title]="supplier().name">{{ supplier().name }}</span>

  @if (supplier().externalNumber; as externalNumber) {
    <span class="supplier-info__number truncate" [title]="externalNumber">{{ externalNumber }}</span>
  }
</div>
